import { schema } from 'normalizr';

export const interactionSchema = new schema.Entity('interactions', {}, { idAttribute: '_id' });
export const interactionListSchema = [interactionSchema];
